import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { BookModel } from '../../../../../interfaces/book.interface';

interface ImagePreviewProps {
  previewImage: string | null;
  storyData: BookModel;
  handleDeleteImage: () => void;
}

const ImagePreview: React.FC<ImagePreviewProps> = ({ previewImage, storyData, handleDeleteImage }) => {
  return (
    <div className="flex flex-col items-center gap-2">
      <div className="relative">
        {previewImage && (
          <div
            className="absolute top-4 right-6 w-10 h-10 bg-white rounded-md">
            <FontAwesomeIcon
              icon={faTrashCan}
              className={`mt-2 text-[#EF4444] text-2xl cursor-pointer`}
              onClick={() => {
                handleDeleteImage();
              }}
            />
          </div>
        )}
        <img
          src={
            previewImage ||
            storyData?.illustrationCharacter?.uploadedImage! ||
            storyData?.uploadedImage!
          }
          alt="Selected"
          className="w-[20rem] h-[20rem] md:w-[25rem] md:h-[25rem] rounded-[1.5rem] object-cover"
        />
      </div>

      <h1 className="w-[19rem] md:w-[24rem] text-xs text-left mx-2">
        AI-generated content may not always be 100% accurate or free
        from errors.
      </h1>
    </div>
  );
};

export default ImagePreview;
